const PoliticasDevolucion = () => {
  return (
    <div>
      <p>
        Si el producto presenta una falla de calidad, podrá solicitarse el
        cambio por otro artículo, crédito en tienda o devolución del dinero. El
        cliente tendrá que informar a info@vanyaychicago.com.ar en un plazo
        máximo de 72 horas de recibida la compra. Se tomará el valor abonado.
      </p>
    </div>
  );
};

export default PoliticasDevolucion;
